import { Box } from 'entities/Box';
import type { SizeFilter } from 'features/BoxSizeFilter/model/types';

export enum BookingMapUnpickableTapKind {
  INACTIVE = 'inactive',
  WRONG_SIZE_GROUP = 'wrongSizeGroup',
}

export interface BookingMapUnpickableTapKindParams {
  targetBox: Box | undefined;
  canPickBox: boolean;
  isSelected: boolean;
  highlightOnlySelected: boolean;
  isAllowedSizeCode: boolean;
  isOccupied: boolean;
  selectedFilter: SizeFilter;
}

export const getBoxUnavailableReason = (params: BookingMapUnpickableTapKindParams): BookingMapUnpickableTapKind | null => {
  const { targetBox, canPickBox, isSelected, highlightOnlySelected, isAllowedSizeCode, isOccupied, selectedFilter } = params;

  if (!targetBox || highlightOnlySelected || !isAllowedSizeCode) {
    return null;
  }

  if (isSelected || canPickBox) {
    return null;
  }

  if (isOccupied) {
    return null;
  }

  if (!targetBox.isActive) {
    return BookingMapUnpickableTapKind.INACTIVE;
  }

  if (selectedFilter !== 'All' && targetBox.sizeCode.sizeGroup !== selectedFilter) {
    return BookingMapUnpickableTapKind.WRONG_SIZE_GROUP;
  }

  return null;
};
